export const USER_ROLES = {
    Anonymous: 'anonymous',
    User: 'user',
    Admin: 'admin',
} as const;

type ObjectValues<T> = T[keyof T]

export type EnumUserRoles = ObjectValues<typeof USER_ROLES>